<template>
  <div>
    <coaching-booking
      v-for="(booking, i) in pastBookings"
      v-bind:key="i"
      :booking="booking"
    />
  </div>
</template>
<script>
export default {
  props: {
    pastBookings: Object,
  },
  data: function(){
    return {
    }
  },
  methods: {
  },
  mounted() {
  },
  computed: {
  }
}
</script>
<style scoped>
</style>